import { IPersonWithEmail } from '@/api/types/response.types'
import Permissions from '@/plugins/permissions/permissions'

export default new class AssigneeAssistant {
  /* Includes "unassigned" (ID: 0) if it's not already included in the list, and moves logged in user just underneath */
  public getFullAssigneeOptions(
    assignees: IPersonWithEmail[],
    permissions: Permissions,
  ): IPersonWithEmail[] {
    const self = assignees.find(p => permissions.isLoggedInUser(p.id))
    const hasUnassigned = assignees.find(a => a.id === 0)

    if (hasUnassigned) {
      assignees = assignees.filter(a => a.id !== 0)
    }

    return [
      {
        id: 0,
        name: 'Unassigned',
        photoUrl: '',
        email: '',
        isGuest: false, // Unassigned is not a guest
      },
      {
        id: self.id,
        email: self.email,
        name: `You (${self.name})`,
        photoUrl: self.photoUrl,
        isGuest: self.isGuest,
      },
      ...assignees
        .filter(p => p.id !== self.id)
        .sort((a, b) => a.name.localeCompare(b.name)),
    ]
  }
}()
